/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ command: NonNullable<unknown> }} Drastic_Tech_Embed_Command_LogInputs */



/**
* | output |
* | --- |
* | "[CREATOR] Command: {command}" |
*
* @param {Drastic_Tech_Embed_Command_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_embed_command_log = /** @type {((inputs: Drastic_Tech_Embed_Command_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Embed_Command_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`[CREATOR] Commande : ${i?.command}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`[ERSTELLER] Befehl: ${i?.command}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`[CREATORE] Comando: ${i?.command}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`[СОЗДАТЕЛЬ] Команда: ${i?.command}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`[CREADOR] Comando: ${i?.command}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`[创建者] 命令：${i?.command}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`[CREATOR] コマンド: ${i?.command}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`[निर्माता] कमांड: ${i?.command}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`[CRIADOR] Comando: ${i?.command}`)
	return /** @type {LocalizedString} */ (`[CREATOR] Command: ${i?.command}`)
});